export default __webpack_public_path__ + "static/media/PAYW-Pro-SemiBold.06347de2.otf";